// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__athWX","layout-container":"Tabs_layout-container__BUCSD","container":"Tabs_container__NM5lB","backLink":"Tabs_backLink__faeRM"};
    if(module.hot) {
      // 1763446807948
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  